/*
 * SOLBELI — Search Backdrop
 * Nuevo asset SOLBELI, no altera Shrine ni el código de Rapid Search.
 * Se activa solo con viewport >= 600px. El overlay no captura resultados.
 */
(function () {
  'use strict';

  var INPUT = '#SolbeliHeaderSearch';
  var WRAPPER = '.solbeli-dawn-inline-search';
  var PANEL = '#rapid-search-results';
  var ACTIVE = 'solbeli-search-backdrop-active';
  var MQ = window.matchMedia('(min-width: 600px)');
  var cssId = 'solbeli-search-backdrop-styles';
  var isOpen = false;
  var panelPointer = false;

  function installStyles() {
    if (document.getElementById(cssId)) return;
    var style = document.createElement('style');
    style.id = cssId;
    style.textContent = [
      '@media (min-width: 600px) {',
      '  body.' + ACTIVE + '::before {',
      '    content: ""; position: fixed; inset: 0;',
      '    background: rgba(0, 0, 0, .48);',
      '    z-index: 2147481000; pointer-events: auto;',
      '  }',
      '  body.' + ACTIVE + ' .shopify-section-group-header-group:has(' + WRAPPER + ') {',
      '    z-index: 2147481100 !important;',
      '  }',
      '  body.' + ACTIVE + ' .shopify-section-group-header-group:has(' + WRAPPER + ') .header-wrapper {',
      '    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, .48);',
      '  }',
      '  body.' + ACTIVE + ' .solbeli-dawn-header .header {',
      '    position: relative;',
      '  }',
      '  body.' + ACTIVE + ' .solbeli-dawn-header .header::before {',
      '    content: ""; position: absolute; inset: 0;',
      '    background: rgba(0, 0, 0, .48);',
      '    z-index: 1; pointer-events: none;',
      '  }',
      '  body.' + ACTIVE + ' .solbeli-dawn-header .header > ' + WRAPPER + ' {',
      '    position: relative; z-index: 2;',
      '  }',
      '  body.' + ACTIVE + ' ' + PANEL + ' {',
      '    z-index: 2147483000 !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function setOpen(open) {
    var next = !!open && MQ.matches;
    if (next === isOpen) return;
    isOpen = next;
    document.body.classList.toggle(ACTIVE, next);
  }

  function init() {
    var input = document.querySelector(INPUT);
    var wrapper = input && input.closest(WRAPPER);
    if (!input || !wrapper) return;
    installStyles();

    function isWithinSearch(node) {
      var panel = document.querySelector(PANEL);
      return !!(node && (wrapper.contains(node) || (panel && panel.contains(node))));
    }

    input.addEventListener('focus', function () { setOpen(true); });

    document.addEventListener('pointerdown', function (event) {
      var panel = document.querySelector(PANEL);
      panelPointer = !!(panel && panel.contains(event.target));
      if (!isOpen || isWithinSearch(event.target)) return;
      setOpen(false);
      input.blur();
    }, true);

    document.addEventListener('focusin', function (event) {
      if (event.target === input) {
        setOpen(true);
      } else if (isOpen && !isWithinSearch(event.target)) {
        setOpen(false);
      }
    });

    input.addEventListener('blur', function () {
      window.requestAnimationFrame(function () {
        if (!isOpen || panelPointer) return;
        if (!isWithinSearch(document.activeElement)) setOpen(false);
      });
    });

    document.addEventListener('pointerup', function () {
      panelPointer = false;
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        setOpen(false);
        input.blur();
      }
    });

    window.addEventListener('pageshow', function () { setOpen(false); });
    if (MQ.addEventListener) {
      MQ.addEventListener('change', function () { setOpen(MQ.matches && document.activeElement === input); });
    } else {
      MQ.addListener(function () { setOpen(MQ.matches && document.activeElement === input); });
    }
    if (document.activeElement === input) setOpen(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
